<template>
  <routed-tab-layout
    variant="primary"
    :tabs="visibleTabs"
    :active-tab-id="activeTab"
  />
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import RoutedTabLayout from '@/components/RoutedTabLayout.vue'

export default {
  name: 'AttendanceLayout',
  components: {
    RoutedTabLayout
  },
  setup () {
    const route = useRoute()
    const store = useStore()

    const orgId = computed(() => store.state.organizationId)

    const tabs = [
      { id: 'timecards', label: 'Time Cards', routeName: 'timecard-editor', icon: 'table', require: (state) => state.permissions.includes('edit_punches') || state.permissions.includes('view_reports') },
      { id: 'punches', label: 'Raw Punches', routeName: 'punch-list', icon: 'business-time', requireGetter: 'canAccessManagePunches' },
      { id: 'geomap', label: 'Geo Mapping', routeName: 'geomap', icon: 'map-marked', requireFeature: 'geo', requireGetter: 'geoEnabled', requirePerm: 'manage_clock_logs' },
      { id: 'clock-logs', label: 'Clock Logs', routeName: 'clock-log-list', icon: 'history', requirePerm: 'manage_clock_logs' },
      { id: 'infractions', label: 'Infractions', routeName: 'discipline-infractions', icon: 'hundred-points', requirePerm: 'manage_discipline', requireFeature: 'discipline', requireGetter: 'disciplineEnabled' },
      { id: 'settings', label: 'Settings', routeName: 'attendance-settings', icon: 'cog', requirePerm: 'edit_settings' }
    ]

    const visibleTabs = computed(() => {
      return tabs.filter(tab => {
        if (tab.requireFeature && !store.state.features.includes(tab.requireFeature)) return false
        if (tab.requirePerm && !store.state.permissions.includes(tab.requirePerm)) return false
        if (tab.requireGetter && !store.getters[tab.requireGetter]) return false
        if (tab.require && !tab.require(store.state, store.getters)) return false
        return true
      })
    })

    const activeTab = computed(() => {
      const name = route.name || ''
      if (name.startsWith('clock-log')) return 'clock-logs'
      if (name === 'geomap') return 'geomap'
      if (name.startsWith('discipline-infraction') || name.startsWith('discipline-event') || name === 'discipline') return 'infractions'
      if (name.startsWith('punch-') || name.startsWith('missed-punch') || name === 'punches') return 'punches'
      if (name.startsWith('timecard') || name.startsWith('shiftcard') || name.startsWith('shift-extend')) return 'timecards'
      if (name.startsWith('entry-states') || name.startsWith('punch-codes') || name.startsWith('discipline-defaults') || name.startsWith('discipline-policies') || name.startsWith('custom-infraction') || name.startsWith('discipline-event-type') || name === 'attendance-settings') return 'settings'
      return ''
    })

    const routedTabs = computed(() => {
      return visibleTabs.value.map(tab => ({
        id: tab.id,
        label: tab.label,
        icon: tab.icon,
        to: { name: tab.routeName, params: { orgId: orgId.value } }
      }))
    })

    return {
      visibleTabs: routedTabs,
      activeTab
    }
  }
}
</script>
